"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exactMetersToMiles = exports.exactMilesToMeters = exports.exactCmtoInch = exports.exactInchtoCm = exports.exactKgtoLbs = exports.exactLbsToKg = exports.METERS_IN_MILE = exports.CM_IN_INCH = exports.POUNDS_IN_KG = void 0;
exports.POUNDS_IN_KG = 2.20462;
exports.CM_IN_INCH = 2.54;
exports.METERS_IN_MILE = 1609.34;
const exactLbsToKg = (value) => {
    return value / exports.POUNDS_IN_KG;
};
exports.exactLbsToKg = exactLbsToKg;
const exactKgtoLbs = (value) => {
    return value * exports.POUNDS_IN_KG;
};
exports.exactKgtoLbs = exactKgtoLbs;
const exactInchtoCm = (value) => {
    return value * exports.CM_IN_INCH;
};
exports.exactInchtoCm = exactInchtoCm;
const exactCmtoInch = (value) => {
    return value / exports.CM_IN_INCH;
};
exports.exactCmtoInch = exactCmtoInch;
const exactMilesToMeters = (value) => {
    return value * exports.METERS_IN_MILE;
};
exports.exactMilesToMeters = exactMilesToMeters;
const exactMetersToMiles = (meters) => {
    return meters / exports.METERS_IN_MILE;
};
exports.exactMetersToMiles = exactMetersToMiles;
